import { render, staticRenderFns } from "./DrageRow.vue?vue&type=template&id=6fbb5614&scoped=true&"
import script from "./DrageRow.vue?vue&type=script&lang=ts&"
export * from "./DrageRow.vue?vue&type=script&lang=ts&"
import style0 from "./DrageRow.vue?vue&type=style&index=0&id=6fbb5614&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb5614",
  null
  
)

export default component.exports